import { Flex, Loader } from "@fluentui/react-northstar";

export const AppLoader: React.FC = () => {
  return (
    <Flex fill vAlign="center" hAlign="center" data-testid="apploader">
      <Loader />
    </Flex>
  );
};
